import {
  SET_SELECTED_OPTION,
  LIST_EVENTS_SUCCESS,
  LIST_EVENTS_FAILURE,
  UPDATE_EVENTS_FILTER,
  CREATE_INVOICE,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_FAILURE,
  GET_CARE_UNIT,
  GET_CARE_UNIT_SUCCESS,
  GET_CARE_UNIT_FAILURE
} from './ReportActionTypes';

export const initialReportState = () => ({
  selectedOption: '',
  eventList: [],
  eventListFilter: {
    from: "",
    before: "",
    careUnitOrganizationId: "",
    opticianOrganizationId: "",
  },
  errorMessage: null,
  isLoading: true,
  careUnits: []
});

const report = (state = initialReportState(), action) => {
  switch (action.type) {
    case SET_SELECTED_OPTION:
      return {
        ...state,
        selectedOption: action.payload,
        isLoading: true
      }
    // FAKTURAUNDERLAG
    case LIST_EVENTS_SUCCESS:
      return {
        ...state,
        eventList: action.events,
        errorMessage: null,
        isLoading: false
      }
    case LIST_EVENTS_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isLoading: false
      }
    case UPDATE_EVENTS_FILTER:
      return {
        ...state,
        eventListFilter: action.filter,
        isLoading: true
      }
    case CREATE_INVOICE:
      return {
        ...state,
        fileURL: null,
        fileCreatedDate: null,
        // isSending: true,
      }
    case CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        fileURL: action.fileURL,
        fileCreatedDate: action.fileCreatedDate,
        // isSending: false,
      }
    case CREATE_INVOICE_FAILURE:
      return {
        ...state,
        sendReferralError: action.message,
        fileURL: null,
        fileCreatedDate: null,
        // isSending: false,
      }
    case GET_CARE_UNIT:
      return {
        ...state,
      }
      case GET_CARE_UNIT_SUCCESS:
        return {
          ...state,
          careUnits: action.careUnit,
      }
    case GET_CARE_UNIT_FAILURE:
      return {
        ...state,
      }
    default:
      return state;
  }
};

export default report;